<template>
  <div class="skeleton bootcamp-card-skel">
    <div
      class="skeleton__box skeleton__animate--white bootcamp-card-skel__left"
    >
      <div
        class="skeleton__box bootcamp-card-skel__pass skeleton__animate--white"
      ></div>
    </div>
    <div class="skeleton__box bootcamp-card-skel__right">
      <h4
        class="skeleton__title skeleton__animate--white bootcamp-card-skel__title"
      ></h4>
      <p class="skeleton__content skeleton__animate--white"></p>
      <p class="skeleton__content skeleton__animate--white"></p>
      <p class="skeleton__content skeleton__animate--white"></p>
      <p class="skeleton__content skeleton__animate--white"></p>
      <p class="skeleton__content skeleton__animate--white"></p>
      <br />
      <br />
      <div class="skeleton__content bootcamp-card-skel__actions">
        <p
          class="skeleton__content skeleton__animate--white bootcamp-card-skel__actions--text"
        ></p>
        <p
          class="skeleton__content skeleton__animate--white bootcamp-card-skel__actions--text"
        ></p>
        <button
          class="skeleton__animate--white bootcamp-card-skel__actions--button"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BootcampCardSkel',
}
</script>

<style lang="scss">
.bootcamp-card-skel {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  padding: 25px;
  min-height: 400px;
  @include tablet {
    padding: 50px 25px;
  }
  &__pass {
    position: absolute;
    right: -50px;
    top: 42px;
    padding: 50px;
    border-radius: 100%;
    display: none;
    @include tablet {
      display: block;
    }
  }
  &__left {
    width: 100%;
    @include tablet {
      width: 25%;
      min-width: 25%;
      position: relative;
    }
  }
  &__right {
    width: 100%;
    height: 100%;
    @include tablet {
      width: 75%;
      min-width: 75%;
      padding: 0 0 0 100px;
    }
  }
  .skeleton__content {
    padding: 0;
    margin: 0 0 5px 0;
    @include tablet {
      max-width: 615px;
    }
  }
  .skeleton__title {
    margin: 0 0 75px 0;
    max-width: 350px;
    @include tablet {
      max-width: 517px;
    }
  }
  &__actions {
    min-width: 100%;
    display: flex;
    justify-content: space-between;
    &--text {
      padding: 0;
      width: 25%;
      margin: 0 auto;
    }
    &--button {
      margin: 0 0 0 auto;
      padding: 5px 50px;
      background: transparent;
      border: none;
    }
  }
}
</style>
